var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"signout"}},[_c('div',[_c('br'),_c('br'),_c('br'),_c('h2',[_vm._v(_vm._s(_vm.$route.params.message))]),_c('br'),_c('br'),_c('br')])])}
var staticRenderFns = []

export { render, staticRenderFns }